<template>
    <div v-if="conversationId > 0" class="container d-flex flex-column justify-content-between">
        <div class="info-chat p-2 d-flex justify-content-between  align-items-center">
            <div @click="openContactDetails" class="d-flex align-items-center contact-header">
                <div class="circle-profile d-flex justify-content-center align-items-center">
                    <i class="fa-solid fa-user"></i>
                </div>

                <div class="ms-3">
                    <p style="margin: 0;">{{ conversationTitle }}</p>
                    <p class="contact-subtitle">{{ contactPhone }}</p>
                </div>
            </div>

            <div class="me-4 d-flex align-items-center">
                <button @click="getMessages()" class=" btn-reload">
                    <i class="fa-solid fa-rotate-right"></i>
                </button>
            </div>
        </div>

        <div class="row scroll-container h-100" id="scroll" data-bs-spy="scroll">
            <div v-for="(mensaje) in mensajes" :key="mensaje.id">
                <div :class="'d-flex ' + (isOutgoing(mensaje) ? 'incommingMessage' : 'sendingMessage')">
                    <div :class="'Message ' + (mensaje.status === 'failed' ? 'message-failed' : '')">
                        <p v-html="formattedText(mensaje.body)"></p>

                        <p v-if="mensaje.error_detail" class="message-error">{{ mensaje.error_detail }}</p>

                        <div class="d-flex justify-content-end align-items-center message-meta">
                            <p>{{ mensaje.timestamp ? formatTime(mensaje.timestamp) : '' }}</p>
                            <div v-if="isOutgoing(mensaje)" class="ms-2 d-flex justify-content-center mt-1 status-indicator" :title="statusLabel(mensaje)">
                                <i v-if="mensaje.status === 'failed'" class="fa-solid fa-circle-exclamation status-failed"></i>
                                <i v-else-if="isRead(mensaje)" class="fa-solid fa-check-double status-read"></i>
                                <i v-else-if="mensaje.status === 'delivered'" class="fa-solid fa-check-double"></i>
                                <i v-else-if="mensaje.status === 'sending'" class="fa-solid fa-clock"></i>
                                <i v-else class="fa-solid fa-check"></i>
                            </div>
                        </div>

                        <button v-if="mensaje.status === 'failed'" @click="retryMessage(mensaje)" :disabled="retryingMessageId === mensaje.id" class="btn-retry">
                            <i class="fa-solid fa-rotate-right"></i>
                            <span>{{ retryingMessageId === mensaje.id ? 'Reintentando...' : 'Reintentar' }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!canSendText" class="template-required p-2">
            <div class="template-required-header">
                <i class="fa-solid fa-lock"></i>
                <span>Ventana de 24 horas cerrada</span>
            </div>
            <p>{{ templateRequiredNote }}</p>
            <div class="template-list">
                <button
                    v-for="template in availableTemplates"
                    :key="template.name"
                    @click="sendTemplate(template)"
                    :disabled="sendingTemplateName === template.name"
                    class="btn-template"
                >
                    <i class="fa-solid fa-paper-plane"></i>
                    <span>{{ sendingTemplateName === template.name ? 'Enviando...' : template.display_name }}</span>
                </button>
            </div>
        </div>

        <div :class="'send-message p-2 container-fluid d-flex justify-content-between align-items-center ' + (!canSendText ? 'send-message-disabled' : '')">
            <div class="d-flex col-11 align-items-center">
                <input
                    v-model="mensajeEnviar"
                    @keyup.enter="sendMessage()"
                    :disabled="!canSendText"
                    type="text"
                    :placeholder="canSendText ? 'Escribe un mensaje' : 'Usa una plantilla para reabrir la conversacion'"
                    class=" ms-4 message w-100"
                >
            </div>

            <div class="me-4 col-2 d-flex align-items-center">
                <button @click="sendMessage()" :disabled="!canSendText" class=" btn-send">
                    <i class="fa-solid fa-paper-plane"></i>
                </button>
            </div>
        </div>

        <div v-if="showContactDetails" class="contact-modal-backdrop" @click.self="closeContactDetails">
            <div class="contact-modal">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="contact-modal-title">Contacto</h5>
                    <button @click="closeContactDetails" class="btn-contact-close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>

                <label class="contact-label">Nombre</label>
                <input v-model="contactNameDraft" type="text" class="contact-input" placeholder="Nombre del contacto">

                <label class="contact-label mt-3">Numero de telefono</label>
                <input :value="contactPhone" type="text" class="contact-input" disabled>

                <p v-if="contactError" class="contact-error">{{ contactError }}</p>

                <button @click="saveContactName" :disabled="savingContact" class="btn-contact-save">
                    <i class="fa-solid fa-floppy-disk"></i>
                    <span>{{ savingContact ? 'Guardando...' : 'Guardar nombre' }}</span>
                </button>
            </div>
        </div>
    </div>
    <div v-else class="container d-flex justify-content-center align-items-center">
        <div class="text-center">
            <h2 class=" edu-au-vic-wa-nt-pre-unique-style">
                Axsistente
                <i class="fa-brands fa-square-whatsapp"></i>
            </h2>
            <p class=" edu-au-vic-wa-nt-pre-unique-style" style="color: white;">
                by axum
            </p>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import Security from '../security';

export default {
    data() {
        return {
            mensajes: [],
            ready: false,
            mensajeEnviar: "",
            pollTimer: null,
            retryingMessageId: 0,
            showContactDetails: false,
            contactNameDraft: "",
            savingContact: false,
            contactError: "",
            canSendText: true,
            availableTemplates: [],
            templateRequiredNote: "Debes usar una plantilla porque el cliente no ha escrito o ya pasaron mas de 24 horas desde su ultimo mensaje.",
            sendingTemplateName: "",
        }
    },
    props: {
        conversationId: Number,
        conversacion: Object,
    },
    computed: {
        conversationTitle() {
            return this.conversacion?.contact_name || this.conversacion?.phone_number || this.conversacion?.wa_id || '';
        },
        contactPhone() {
            return this.conversacion?.phone_number || this.conversacion?.wa_id || '';
        },
    },
    updated() {
        this.ready = false
        const contenedor = document.getElementById('scroll');
        if (contenedor) {
            contenedor.scrollTop = contenedor.scrollHeight;
        }
    },
    beforeMount() {
        this.getMessages();
        this.pollTimer = setInterval(() => this.getMessages(false), 7000);
    },
    beforeUnmount() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
        }
    },
    methods: {
        formatTime(timestamp) {
            const date = new Date(timestamp);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        },
        formattedText(text) {
            if (!text) return "";
            return text.replace(/\*(.*?)\*/g, "<b>$1</b>");
        },
        isOutgoing(mensaje) {
            return mensaje?.direction === 'outgoing' || mensaje?.esEnviado === true;
        },
        isRead(mensaje) {
            return mensaje?.status === 'read' || mensaje?.visto === true;
        },
        statusLabel(mensaje) {
            const labels = {
                sending: 'Enviando',
                sent: 'Enviado',
                delivered: 'Entregado',
                read: 'Leido',
                failed: 'Fallido',
            };
            return labels[mensaje?.status] || mensaje?.status || '';
        },
        openContactDetails() {
            this.contactNameDraft = this.conversacion?.contact_name || "";
            this.contactError = "";
            this.showContactDetails = true;
        },
        closeContactDetails() {
            this.showContactDetails = false;
        },
        saveContactName() {
            this.contactError = "";
            this.savingContact = true;

            fetch(
                process.env.VUE_APP_API_URL +
                `/api/whatsapp/chats/${this.conversationId}`,
                Security.requestOptionsJson("PUT", { contact_name: this.contactNameDraft.trim() })
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        this.contactError = data.message || "No se pudo actualizar el contacto.";
                        return;
                    }

                    const chat = data?.data?.chat;
                    this.$emit("contact-updated", chat);
                    this.showContactDetails = false;
                })
                .catch(() => {
                    this.contactError = "No se pudo conectar con el servidor.";
                })
                .finally(() => {
                    this.savingContact = false;
                });
        },
        getMessages(showErrors = true) {
            if (!this.conversationId) {
                return;
            }

            fetch(
                process.env.VUE_APP_API_URL +
                `/api/whatsapp/chats/${this.conversationId}/messages`,
                Security.requestOptionsGet()
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        if (showErrors) {
                            Swal.fire({
                                icon: "error",
                                title: data.message + data.error,
                                showConfirmButton: false,
                                timer: 1500,
                            });
                        }
                    } else {
                        this.mensajes = data.data.messages
                        this.canSendText = data.data.can_send_text === true
                        this.availableTemplates = Array.isArray(data.data.available_templates)
                            ? data.data.available_templates
                            : []
                        this.templateRequiredNote = data.data.template_required_note || this.templateRequiredNote
                    }
                });

            this.ready = true
        },
        sendMessage() {
            if (!this.canSendText) {
                return;
            }

            const message = this.mensajeEnviar.trim();
            if (!message) {
                return;
            }

            fetch(
                process.env.VUE_APP_API_URL +
                `/api/whatsapp/chats/${this.conversationId}/messages`,
                Security.requestOptionsJson("POST", { message })
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        Swal.fire({
                            icon: "error",
                            title: data.message + data.error,
                            showConfirmButton: false,
                            timer: 1500,
                        });
                        this.getMessages(false)
                    } else {
                        this.mensajeEnviar = ''
                        this.getMessages(false)
                    }
                });
        },
        sendTemplate(template) {
            if (!template?.name) {
                return;
            }

            this.sendingTemplateName = template.name;
            fetch(
                process.env.VUE_APP_API_URL +
                `/api/whatsapp/chats/${this.conversationId}/templates`,
                Security.requestOptionsJson("POST", { template_name: template.name })
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        Swal.fire({
                            icon: "error",
                            title: data.message || "No se pudo enviar la plantilla",
                            showConfirmButton: false,
                            timer: 2200,
                        });
                    }
                    this.getMessages(false);
                })
                .catch(() => {
                    Swal.fire({
                        icon: "error",
                        title: "No se pudo conectar con el servidor",
                        showConfirmButton: false,
                        timer: 2200,
                    });
                })
                .finally(() => {
                    this.sendingTemplateName = "";
                });
        },
        retryMessage(mensaje) {
            if (!mensaje?.id) {
                return;
            }

            this.retryingMessageId = mensaje.id;
            fetch(
                process.env.VUE_APP_API_URL +
                `/api/whatsapp/messages/${mensaje.id}/retry`,
                Security.requestOptionsJson("POST", {})
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        Swal.fire({
                            icon: "error",
                            title: data.message || "No se pudo reintentar el mensaje",
                            showConfirmButton: false,
                            timer: 2200,
                        });
                    }
                    this.getMessages(false);
                })
                .catch(() => {
                    Swal.fire({
                        icon: "error",
                        title: "No se pudo conectar con el servidor",
                        showConfirmButton: false,
                        timer: 2200,
                    });
                })
                .finally(() => {
                    this.retryingMessageId = 0;
                });
        }
    }
}
</script>

<style scoped>
.container {

    background-image: url('@/assets/fondoWa.jpg');
    background-size: cover;
    /* Asegura que la imagen cubra todo el fondo */
    background-position: center;
    /* Centra la imagen */
    background-repeat: no-repeat;
    /* Evita que la imagen se repita */
    width: 100%;
    border-radius: 10px;
    /* Ajusta el ancho del contenedor */
    height: 100%;
    /* Ajusta el alto del contenedor */
    padding: 0;
    margin: 0;
}

#scroll {
    overflow-y: scroll;
    /* height: 60vh; */
}

.info-chat {
    border-radius: 10px 10px 0px 0px;
    background: #2e3951;
    /* width: 100%; */
    color: white;

}

.contact-header {
    cursor: pointer;
    border-radius: 7px;
    padding: 4px 8px;
}

.contact-header:hover {
    background-color: rgba(255, 255, 255, 0.08);
}

.contact-subtitle {
    color: #b9c2da;
    font-size: 12px;
    margin: 2px 0 0;
}

.contact-modal-backdrop {
    position: absolute;
    inset: 0;
    z-index: 20;
    background-color: rgba(10, 14, 24, 0.58);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 72px;
}

.contact-modal {
    width: min(420px, calc(100% - 32px));
    background-color: #2e3951;
    color: white;
    border-radius: 8px;
    padding: 18px;
    box-shadow: 0 16px 40px rgba(0, 0, 0, 0.35);
}

.contact-modal-title {
    margin: 0;
    font-size: 18px;
}

.btn-contact-close {
    border: 0;
    border-radius: 5px;
    background-color: #3c4763;
    color: white;
    width: 32px;
    height: 32px;
}

.contact-label {
    color: #cbd3e6;
    font-size: 13px;
    margin-bottom: 6px;
}

.contact-input {
    width: 100%;
    border: 0;
    border-radius: 5px;
    background-color: #434e6b;
    color: white;
    padding: 9px;
    font-size: 14px;
}

.contact-input:disabled {
    opacity: 0.75;
}

.contact-error {
    color: #ffd0d0;
    background-color: rgba(120, 35, 35, 0.35);
    border-radius: 5px;
    padding: 8px;
    font-size: 13px;
    margin: 12px 0 0;
}

.btn-contact-save {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    margin-top: 16px;
    border: 0;
    border-radius: 5px;
    background-color: #6f85bc;
    color: white;
    padding: 9px 12px;
}

.btn-contact-save:hover {
    background-color: #85a1ee;
}

.btn-contact-save:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.send-message {
    border-radius: 0px 0px 10px 10px;
    background: #2e3951;
    /* width: 100%; */
    color: white;

}

.send-message-disabled {
    border-radius: 0;
    opacity: 0.85;
}

.template-required {
    background-color: #263148;
    color: white;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.template-required-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    color: #f3d38a;
}

.template-required p {
    color: #dce3f4;
    font-size: 12px;
    margin: 6px 0 8px;
}

.template-list {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.btn-template {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    border-radius: 5px;
    background-color: #128c7e;
    color: white;
    padding: 7px 10px;
    font-size: 13px;
}

.btn-template:hover {
    background-color: #0f7d70;
}

.btn-template:disabled,
.btn-send:disabled,
.message:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

.circle-profile {
    color: #7389c1;
    width: 40px;
    /* Ancho del circulo */
    height: 40px;
    /* Alto del circulo */
    border-radius: 50%;
    /* Hacer las esquinas redondeadas al 50% */
    background-color: #3498db52;
    /* Color de fondo, puedes cambiarlo */
}

.Message {
    border: #3498db52;
    color: white;
    /* background-color: #2a344b; */
    width: 45%;
    margin: 15px;
    padding: 10px;
    border-radius: 5px;
}

.message-failed {
    background-color: #5b2f3b !important;
    border: 1px solid rgba(255, 140, 140, 0.35);
}

.message-error {
    color: #ffd6d6;
    font-size: 12px;
    line-height: 1.35;
    margin-top: 8px;
    margin-bottom: 0;
}

.message-meta p {
    margin: 0;
}

.status-indicator {
    font-size: 12px;
}

.status-read {
    color: #7389C1;
}

.status-failed {
    color: #ffb2b2;
}

.btn-retry {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    border: 0;
    border-radius: 5px;
    background-color: rgba(255, 255, 255, 0.16);
    color: white;
    padding: 5px 8px;
    font-size: 12px;
}

.btn-retry:hover {
    background-color: rgba(255, 255, 255, 0.24);
}

.btn-retry:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.sendingMessage {
    justify-content: start;
}

.sendingMessage .Message {
    background-color: #3c4763;
}

.incommingMessage {
    justify-content: end;
}

.incommingMessage .Message {
    background-color: #005C4B;
}

h2 {
    color: white;
}

/* Scroll */

/* Scroll personalizado para navegadores basados en Webkit */
::-webkit-scrollbar {
    width: 12px;
    /* Ancho del scroll vertical */
    height: 12px;
    /* Alto del scroll horizontal */
}

::-webkit-scrollbar-track {
    background: #ffffff00;
    /* Fondo del track */
    border-radius: 10px;
    /* Bordes redondeados */
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(45deg, #2E3951, #2575fc);
    /* Color degradado del scroll */
    border-radius: 10px;
    /* Bordes redondeados */
}

::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(45deg, #2E3951, #1e6ae6);
    /* Cambio de color al pasar el mouse */
}

/* Scroll personalizado para Firefox */
* {
    scrollbar-width: thin;
    /* Grosor del scrollbar */
    scrollbar-color: #2E3951 #ffffff1b;
    /* Color del thumb y track */
}

/* Scroll dentro de un contenedor especifico */
.scroll-container {
    /* max-height: 400px; Altura maxima del contenedor */
    overflow-y: auto;
    /* Activar scroll vertical */
    /* padding: 10px; Espaciado interno */
    /* border: 1px solid #ddd; Bordes del contenedor */
    border-radius: 8px;
    /* Bordes redondeados */
    /* background-color: #fff; Fondo del contenedor */
    width: 100%;
    height: 40%;
    margin: 0;
}


.edu-au-vic-wa-nt-pre-unique-style {
    font-family: "Edu AU VIC WA NT Pre", cursive;
    font-optical-sizing: auto;
    font-weight: 200;
    /* Cambia el valor segun lo que necesites */
    font-style: thin;
}

.btn-reload {
    margin: 0;
    border-radius: 5px;
    border: 0px;
    background-color: #3c4763;
    padding-inline: 15px;
    padding-block: 5px;
}

.btn-reload:hover {

    background-color: #434e6b;

}

.btn-reload:active {

    background-color: #515e81;

}

.btn-send {
    margin: 0;
    height: 35px;
    border-radius: 0px 5px 5px 0px;
    border: 0px;
    background-color: #6f85bc;
    padding-inline: 15px;
    padding-block: 5px;
}

.btn-send:hover {

    background-color: #85a1ee;

}

.btn-send:active {

    background-color: #515e81;

}

.message {
    height: 35px;
    border-radius: 5px 0px 0px 5px;
    background-color: #434e6b;
    border: none;
    color: white;
    padding-left: 6px;
    font-size: 13px;
}
</style>
